import * as THREE from 'three';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { calArcWallShapePoints } from '@/editor/utils';
import { pixelRatio2d } from '@/editor/math/const';
import { disposeAllChildren } from '../utils';
import { ENTITY_RENDER_ORDER, virtual2dWallColor } from '@/editor/constant/entity';
import { globalStores } from '@/editor/stores';
import BaseModel2d from './BaseModel2d';

interface IArcWallBaseParams {
  start: IPoint2d;
  end: IPoint2d;
  thickness: number;
  center: IPoint2d;
  clockwise: boolean;
}

class VirtualArcWall extends BaseModel2d {
  constructor() {
    super();

    this.setDisplayOrder(ENTITY_RENDER_ORDER.virturalArcWall);
    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);
  }

  private createModel(params: IArcWallBaseParams) {
    // 起点、终点调换，因为计算时是按顺时针方向计算的
    const shapePts = calArcWallShapePoints(params);

    const heartShape = new THREE.Shape();
    const len = shapePts.length;
    for (let i = 0; i < len; i++) {
      if (i === 0) heartShape.moveTo(shapePts[i].x / pixelRatio2d, shapePts[i].y / pixelRatio2d);
      heartShape.lineTo(shapePts[i].x / pixelRatio2d, shapePts[i].y / pixelRatio2d);
    }

    const geometry = new THREE.ShapeGeometry(heartShape);
    const material = new THREE.MeshBasicMaterial({ color: virtual2dWallColor, transparent: true, opacity: 0.6 });
    const mesh = new THREE.Mesh(geometry, material);
    this._modelGroup.add(mesh);
  }

  update(params: IArcWallBaseParams) {
    this.clearVirtualModel();
    this.createModel(params);
  }

  private clearVirtualModel() {
    disposeAllChildren(this._modelGroup);
  }
}

export default VirtualArcWall;
